<template>
    <v-container fluid fill-height>
        <v-layout row pt-3>
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3" text-center>
                    <barcode :value="items[0].DROP_QUICKPIN" tag="svg" format="CODE128A"
                             displayValue="false"
                             width="2"></barcode>
                </v-flex>
                <div class="ml-4 pa-5">
                    <h2 style="text-align: center" class="mb-5">ข้อมูลพัสดุ</h2>
                    <p>ชื่อพัสดุ : {{ items[0].SU_FULLNAME }}</p>
                    <p>บ้านเลขที่ : {{ items[0].PD_ADDR }}</p>
                    <p>เลขที่อ้างอิง :</p>
                    <p v-for="(item,key) in items" :key="key">{{ item.SU_CODE }}</p>
                    <p>เบอร์โทรศัพท์ : {{ getLocalItem().box24_mobile }}</p>
                </div>
                <div class="mt-6 ml-6">
                    <v-btn color="#1565C0"
                           large
                           dark
                           @click="dialog = true">
                        แสดงรหัสเปิดตู้
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290" persistent>
            <v-card>
                <v-card-title>ยืนยันที่จะแสดงรหัสเปิดตู้</v-card-title>
                <v-card-text style="color: #ff2e34">* หมายเหตุจะมีการบันทึก Username คนที่กดปุ่มนี้เพื่อกันการทุจริต
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="openPickUpQuckpin(items[0].PICKUP_QUICKPIN)">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1"
                           text
                           @click="dialog = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_quickpin" max-width="290" persistent>
            <v-card>
                <v-card-title v-format="'0000-0000-0000'">{{ items[0].PICKUP_QUICKPIN }}</v-card-title>
                <v-flex text-center class="mt-5">
                    <qrcode-vue :value="items[0].PICKUP_QUICKPIN" size="150" level="H"></qrcode-vue>
                </v-flex>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="goto('add-order-box24')">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import EventBus from '@/EventBus'
    import axios_box24 from '@/axios_box24'
    import axios from '@/axios';
    import QrcodeVue from 'qrcode.vue'
    import VueBarcode from 'vue-barcode';

    export default {
        name: "BarcodeOrderBox24",
        components: {
            'barcode': VueBarcode,
            QrcodeVue,
        },
        data() {
            return {
                searchData: {
                    ntRunno: this.getLocalItem().nt_runno,
                },
                items: [],
                itemSelected: [],
                progress: true,
                dialog: false,
                dialog_quickpin: false,
                today: new Date().toISOString().substr(0, 10),
                api_token: '',
                mobileNumber: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'พัสดุนอกเวลา', back_route: 'add-order-box24'})
            this.getDataWithOrderId()

            try {
                this.getTokenBox24().then((res) => {
                    this.api_token = res.data.data.api_token

                    // this.getDropQuickPin()
                    if (this.getLocalItem().itemSelected.DROP_QUICKPIN) {
                        this.items = this.getLocalItem().itemSelected
                    }
                })
                        .catch(err => {
                            if (err.response) {
                                this.error.status = err.response.data.status;
                                this.error.error_code = err.response.status;
                                if (err.response.status === 401) {
                                    this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน Box24 ไม่ถูกต้อง'
                                } else {
                                    this.error.msg = err.response.data.msg
                                }

                                console.log(this.error)
                            }
                        })
            } catch (err2) {
                console.log(err2.message)
            }
        },
        methods: {
            goto(route_name) {
                this.dialog_quickpin = false
                return this.$router.push({name: route_name})
            },
            async openPickUpQuckpin() {
                try {
                    let user_id = this.getLocalItem().user_id
                    this.items.forEach(function (value) {
                        let formData = {
                            su_runno: value.SU_RUNNO,
                            order_id: value.ORDER_ID,
                            pickup_quickpin: value.PICKUP_QUICKPIN,
                            username: user_id,
                        }
                        // console.log(formData)
                        axios.post('/SaveLogOpenQuickpin', formData)
                                .then(res => {
                                    // console.log('SaveLogOpenQuickpin', res.data)
                                })
                    })
                    this.dialog = false
                    this.dialog_quickpin = true
                } catch (err) {
                    console.log(err.message)
                }
            },
            async getDataWithOrderId() {
                try {
                    axios.post("/GetDataWithOrderId", {'order_id': this.getLocalItem().box24_order_id}).then((res) => {
                        console.log('GetDataWithOrderId', res.data)
                        this.items = res.data.data;
                    });
                } catch (err) {
                    console.log(err.message);
                }
            },
        }
    }
</script>

<style scoped>

</style>